import EDI from './EDI';
export default EDI;
